<template>
  <div class="layout-nav">
    <nav class="navbar navbar-dark bg-dark">
      <router-link class="navbar-brand" :to="{ name: 'dashboard' }">
        <img
          src="@/assets/images/logo-sesb-navbar.png"
          class="nav-logo"
          v-if="currentUrl == 'https://sesb-api.inference.asia'"
        />
        <img src="@/assets/images/ilsas-logo-navbar.png" class="nav-logo" v-else />
      </router-link>
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <router-link class="nav-link" :to="{ name: 'dashboard' }">
            <font-awesome-icon :icon="['fas', 'chart-area']" class="mr-md-3" />
            <span class="d-none d-lg-block">Dashboard</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" :to="{ name: 'list' }">
            <font-awesome-icon :icon="['fas', 'th-large']" class="mr-md-3" />
            <span class="d-none d-lg-block">Report View</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" :to="{ name: 'map' }">
            <font-awesome-icon :icon="['fas', 'compass']" class="mr-md-3" />
            <span class="d-none d-lg-block">Map View</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" :to="{ name: 'maintenance' }">
            <font-awesome-icon :icon="['fas', 'hammer']" class="mr-md-3" />
            <span class="d-none d-lg-block">Maintenance List</span>
          </router-link>
        </li>
        <li class="nav-item" v-if="!hideOnLive">
          <router-link class="nav-link" :to="{ name: 'erms' }">
            <font-awesome-icon :icon="['fas', 'columns']" class="mr-md-3" />
            <span class="d-none d-lg-block">ERMS</span>
          </router-link>
        </li>
      </ul>
      <ul class="navbar-nav ml-auto">
        <li class="nav-item dropdown">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            id="navbarDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <img
              class="user-avatar"
              src="@/assets/images/user-placeholder.png"
            />
          </a>
          <div class="clearfix"></div>
          <div
            class="dropdown-menu dropdown-menu-right"
            aria-labelledby="navbarDropdown"
          >
            <span class="dropdown-item small text-muted">{{ username }}</span>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item small" href="#" @click.prevent="doLogout()">
              Sign out
              <font-awesome-icon :icon="['fas', 'sign-out-alt']" class="ml-3" />
            </a>
          </div>
        </li>
      </ul>
    </nav>
    <slot />
  </div>
</template>

<script>
import API from "@/api";

export default {
  name: "defaultNavbar",
  data() {
    return {
      hideOnLive: false,
      username: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).username
        : "",
      currentUrl: process.env.VUE_APP_API_URL,
    };
  },
  methods: {
    doLogout() {
      localStorage.clear();
      this.$router.push({ name: "login" });
    },
  },
  mounted() {
    if (API.apiUrl() == "https://sesb-api.inference.asia") {
      this.hideOnLive = true;
    }
  },
};
</script>
